import React from "react";

// SCSS
import "./resumeButton.scss";

const resumeButton = (props) => (
//  const  onClick={()=> window.open(${props.link}, "_blank")};


<a style={{color: "Black", textDecoration: "underline"}} href="https://drive.google.com/file/d/1noTciai1O4emj3bwpjE5JTOwpM9A64q0/view?usp=sharing" target="_blank">

VIEW RESUME</a> 

);

export default resumeButton;
